var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 12,
    viewBox: "0 0 43 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BB2025",
    strokeLinecap: "square",
    strokeWidth: 4,
    d: "M6.5,5.5 L40.5,5.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB2025",
    points: "0 6 7 0 7 12"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-back.171434c8.svg";
export { ForwardRef as ReactComponent };